import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { LocalStorageKeyEnum } from '../../localStorage.key.enum';

@Injectable()
export class AuthService {

  constructor(
    private router: Router,
    public jwtHelper: JwtHelperService,
    private route: ActivatedRoute
  ) { }

  isAuthenticated(): boolean {
    if (localStorage.getItem(LocalStorageKeyEnum.USER)) {
      const token = JSON.parse(localStorage.getItem(LocalStorageKeyEnum.USER));
      try {
        let isExpired = this.jwtHelper.isTokenExpired(token);
        if (isExpired) {
    /*       this.authService.initState.subscribe(() => {
            this.refreshToken();
          }) */
          return true;
        }
        return true;
      } catch (error) {
        console.error(error);
        this.router.navigate(['login'], { queryParams: { returnUrl: window.location.pathname || '/' } });
      }
    }
  }
/* 
  refreshToken() {
    // Refresh the token
    return this.authService.refreshAuthToken(GoogleLoginProvider.PROVIDER_ID).then((result) => {
      // if no error set the new token
      this.authService.authState.subscribe(async (user: any) => {
        let userLocalStorage: any = JSON.parse(localStorage.getItem(LocalStorageKeyEnum.USER));
        localStorage.setItem(LocalStorageKeyEnum.USER, JSON.stringify(userLocalStorage));
      });
    }).catch((err) => {
      console.log(this.authService);
      console.log(err);
      this.router.navigate(['login'], { queryParams: { returnUrl: window.location.pathname || '/' } });
    });
  } */

  logout() {
    localStorage.removeItem(LocalStorageKeyEnum.USER);
    localStorage.removeItem(LocalStorageKeyEnum.PHOTO);
    localStorage.removeItem(LocalStorageKeyEnum.PERMISSIONS);
    localStorage.removeItem(LocalStorageKeyEnum.PERMISSIONS_DOT_ANNOTATION);

    
  }

}
